import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import DataBucketList from "./components/DataBucketList";

const DataSetting = () => {
  const { t } = useTranslation();
  const { projectId = "" } = useParams<{ projectId: string }>();

  return (
    <div className="max-w-5xl py-6">
      <div className="flex flex-col gap-1 px-4 sm:px-0">
        <h3 className="text-lg font-semibold text-gray-900">{t("Data")}</h3>
        <p className="text-sm text-gray-500">{t("Manage your custom data")}</p>
      </div>

      <div className="mt-6 grid gap-8 md:grid-cols-2">
        <DataBucketList title={t("Account groups")} type="COMPANY" projectId={projectId} />
        <DataBucketList title={t("Contact groups")} type="CONTACT" projectId={projectId} />
      </div>
    </div>
  );
};

export default DataSetting;
